module.exports = __webpack_public_path__ + "media/sfx_enter_3.417e050a.mp3";